import { useState, useEffect } from 'react';

const IsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1023);
  const updateMedia = () => {
    setIsDesktop(window.innerWidth > 1023);
  };

  useEffect(() => {
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  }, []);

  return isDesktop;
};

export default IsDesktop;
